import { FeatureDefinition } from '../entities';

export const restoreSubscriptionExperiment = 'restore_subscription';

export enum RestoreSubscriptionExperimentGroups {
  CONTROL = 'control',
  TEST = 'test',
}

export const restoreSubscriptionExperimentConfig: FeatureDefinition = {
  defaultValue: RestoreSubscriptionExperimentGroups.CONTROL,
};
